import { render, staticRenderFns } from "./ProductRecordAdd.vue?vue&type=template&id=7e285fce&scoped=true"
import script from "./ProductRecordAdd.vue?vue&type=script&lang=js"
export * from "./ProductRecordAdd.vue?vue&type=script&lang=js"
import style0 from "./ProductRecordAdd.vue?vue&type=style&index=0&id=7e285fce&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7e285fce",
  null
  
)

export default component.exports